import React, { useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const Material = ({ showFooter = true }) => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('opacity-100', 'translate-y-0');
                        entry.target.classList.remove('opacity-0', 'translate-y-5');
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );

        document.querySelectorAll('.service-card').forEach((el) => {
            el.classList.add('opacity-0', 'translate-y-5', 'transition-all', 'duration-600', 'ease-in-out');
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Navbar />
            <section id="materials" className="bg-gray-100 py-20">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        Raw Materials We Use
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">📋</div>
                            <h3 className="text-xl mb-2">Food Grade Paper Board</h3>
                            <p>High-quality virgin paper board (230-300 GSM) sourced from certified suppliers, safe for food contact.</p>
                        </div>
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">🛡</div>
                            <h3 className="text-xl mb-2">PE Coating</h3>
                            <p>Polyethylene (PE) coating for waterproofing and heat resistance, applied on the inner surface.</p>
                        </div>
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">🎨</div>
                            <h3 className="text-xl mb-2">Food Safe Inks</h3>
                            <p>Non-toxic, food-grade printing inks for custom designs and branding that won't contaminate beverages.</p>
                        </div>
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">🔗</div>
                            <h3 className="text-xl mb-2">Adhesive</h3>
                            <p>Food-safe adhesive for sealing cup seams, ensuring leak-proof construction and durability.</p>
                        </div>
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">📏</div>
                            <h3 className="text-xl mb-2">Quality Paper Rolls</h3>
                            <p>Pre-cut paper rolls in various sizes, sourced from sustainable forestry with proper certifications.</p>
                        </div>
                        <div className="service-card bg-white p-8 rounded-lg text-center shadow-lg hover:-translate-y-1 transition-transform">
                            <div className="text-5xl mb-4 text-[#4a7c59]">✅</div>
                            <h3 className="text-xl mb-2">Certified Materials</h3>
                            <p>All materials meet ISI, BIS, and international food safety standards for beverage packaging.</p>
                        </div>
                    </div>
                </div>
            </section>
            {showFooter && <Footer />}
            <div className="fixed bottom-5 right-5 flex flex-col gap-3 z-20">
                <a
                    href="tel:+919426788499"
                    className={`bg-sky-500 text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-sky-700 transition-all`}
                    title="Call Us"
                >
                    <Phone />
                </a>
                <a
                    href="https://wa.me/+919426788499"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-[#3ed145] text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-[#2f8734] transition-all`}
                    title="Message on WhatsApp"
                >
                    <FaWhatsapp className='h-12 w-8' />
                </a>
            </div>
        </>
    );
};

export default Material;